import { createContext, useContext } from "react";
import { ConfirmModalProviderHookProps } from "./ConfirmModalProvider.types.js";

export const ConfirmModalContext = createContext<ConfirmModalProviderHookProps>({} as ConfirmModalProviderHookProps);

export const useConfirmModalContext = () => useContext(ConfirmModalContext);
